import { object } from 'common/helpers'


export const initialState = {
  data: [],
  filterValue: 'currentWeek',
}

export const setLeaderBoardData = (state, payload) => (
  object.set(state, 'data', payload)
)
